import $ from 'jquery';
import 'what-input';
import slick from 'slick-carousel';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';


$(document).foundation();

// slick carousel
$("div.carousel, div.testimonials-slider").slick({
  // normal options...
	autoplay: true,
	cssEase: 'linear',
  slidesToShow: 1,
	slidesToScroll: 1,
  infinite: true,
  swipeToSlide: true,
  dots: true,
  arrows: true,
  autoplaySpeed: 8000
});

// tablesaw table plugin
$(function () {
  $(document).foundation();

  $("*[data-link]").click(function(){
    window.location = $(this).data('link');
    return false;
  });
  var origc;
  origc = $('.bluebg').css('fill');
  $('#service1').hover(function(){
    origc = $('.bluebg').css('fill');
    $('.bluebg').css('fill', '#999');
  }, function() {
    $('.bluebg').css('fill', origc);
  });

  var origc2;
  origc2 = $('.pinkbg').css('fill');
  $('#service2').hover(function(){
    origc = $('.pinkbg').css('fill');
    $('.pinkbg').css('fill', '#ccc');
  }, function() {
    $('.pinkbg').css('fill', origc2);
  });

  $('.play').click(function(){
    $(this).prev().get(0).play();
    $(this).hide();
    return false;
  });

  reposition();

  $(window).on('resize', function(){
        setTimeout(reposition, 100);
  });
  $(window).scroll(function(){
    ( $(this).scrollTop() > 100 ) ? $("#totop").addClass('active') : $("#totop").removeClass('active');
  });

  function reposition() {
    if (Foundation.MediaQuery.atLeast('large')) {
    } else {
    }
  }

});

